<template>
        <div class="d-flex pt-2 pl-2 pb-2 ai-center">
            <span style="display: inherit;">
                <icon :name="icon" class="text-icon" scale="1.5"></icon>
            </span>
            <div class="d-flex">
                <span class="fs-xl text mx-2">
                    <slot></slot>
                </span>
            </div>
        </div>
        <!-- <span class="fs-xxl text mx-2">{{title}}</span> -->
</template>
<script>
export default {
    props: ['icon']
}
</script>
<style>

</style>